import {createContext, useState} from 'react';
import {ReactSetState} from '../types/types';
import {iProvider} from './types';

interface IProgressContext {
  progress: number;
  setProgress: ReactSetState<number>;
}

const defaultProgressContext: IProgressContext = {
  progress: 0,
  setProgress: () => null
};

export const ProgressContext = createContext<IProgressContext>(defaultProgressContext);

const ProgressProvider = ({children}: iProvider): React.ReactElement => {
  const [progress, setProgress] = useState(defaultProgressContext.progress);

  return <ProgressContext.Provider value={{progress, setProgress}}>{children}</ProgressContext.Provider>;
};

export default ProgressProvider;
